export function ThreeDots({ className }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center gap-10 ${className}`}>
      <div className="w-2 h-2 bg-brandRed rounded-full"></div>
      <div className="w-2 h-2 bg-brandGreen rounded-full"></div>
      <div className="w-2 h-2 bg-brandBlue rounded-full"></div>
    </div>
  );
}
